import { useTranslations } from "@/lib/static-intl";

const PostCmtMentionInput = ({
  textAreaRef,
  isInputInFocus,
  textValue,
  handleInputChange,
  makeInputFocus,
}) => {
  const explorePostDetailsT = useTranslations("explore.explore_post_details");

  return (
    <textarea
      ref={textAreaRef}
      className={`outline-none bg-transparent placeholder:tracking-tight placeholder:font-light text-black dark:text-white ${textValue?.length > 0 && "px-2 py-1"
        } text-base leading-5 ${isInputInFocus && "w-full"} resize-none caret-red`}
      rows={1}
      value={textValue}
      placeholder={explorePostDetailsT("say_something")}
      onFocus={makeInputFocus}
      onChange={handleInputChange}
    />
  );
};

export default PostCmtMentionInput;
